export default "__VITE_ASSET__DxqpYu2k__"